import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_secured/ai-hub')({
  loader: async ({ context }) => {
    const i18n = await context.getInstance('i18n', '@mint/routing');
    await context.getInstance('i18n', '@myn/ai-hub');
    const title = i18n.t('AI Hub | MINT');
    return { title };
  },
  head({ loaderData }) {
    const title = loaderData?.title;
    return {
      meta: [
        {
          title,
        },
      ],
    };
  },
});
